import { useGlobalDialog } from '@/hooks/useGlobalDialog'

/**
 * 40035：会员套餐过期（后端 Gate③ `MemberPlanReadonlyMiddleware`）。
 *
 * 过期 / 无套餐的会员在房东专属前缀上的写操作会被后端拒绝。提示统一收在这里，
 * 让 `src/utils/http.ts` 只留一行转发，不再堆弹窗 / 节流 / 样式细节。
 *
 * 两个已知细节：
 * - 1 秒内只弹一次：一次保存常同时发多个请求，避免并发堆出多个弹窗；隔开后的重复提示是预期的。
 * - 页面在 `code !== 200` 分支自己也会 `toast.error(res.message)`，会和弹窗叠成两个提示，
 *   所以弹窗出现后临时屏蔽页面级 toast（类名见 `src/App.vue`），时长覆盖 toast 自身展示周期。
 */
const PROMPT_INTERVAL = 1000
const TOAST_SILENCE_MS = 2500
const TOAST_SILENCE_CLASS = 'plan-expired-silence'

let lastPromptAt = 0
let silenceTimer: ReturnType<typeof setTimeout> | null = null

const silencePageToast = () => {
  document.body.classList.add(TOAST_SILENCE_CLASS)
  if (silenceTimer) clearTimeout(silenceTimer)
  silenceTimer = setTimeout(() => {
    document.body.classList.remove(TOAST_SILENCE_CLASS)
    silenceTimer = null
  }, TOAST_SILENCE_MS)
}

/**
 * 弹「只读，去续费」提示。
 *
 * @param message 后端 message（缺省走标准文案）
 */
export function showPlanExpiredPrompt(message?: string) {
  const now = Date.now()
  if (now - lastPromptAt < PROMPT_INTERVAL) return
  lastPromptAt = now

  silencePageToast()
  useGlobalDialog().confirm({
    title: '提示',
    content: message || '套餐已过期，当前为只读模式，请续费后重试',
    cancelText: '取消',
    confirmText: '去续费',
    onConfirm: () => {
      uni.navigateTo({ url: '/pages/rental-manage/mine/Purchase' })
    },
  })
}
